import notify from "../../hook/useNotification";
import { useGetData } from "../../hooks/useGetData";
import { useInsertData } from "../../hooks/useInsertData";
import { GET_ACCESS_TOKEN_TAOBAO,GET_TAOBAO_PRODUCTS,RESET_TAOBAO_PRODUCTS,SAVE_TAOBAO_PRODUCT } from "../type"



export const getAccessToken=()=>async(dispatch)=>{
        try {
            const response = await useGetData(`/api/v1/taobao/createAccessToken`);

            dispatch({
                type:GET_ACCESS_TOKEN_TAOBAO,
                payload:response
            });
        } catch (error) {
            dispatch({
                type: GET_ACCESS_TOKEN_TAOBAO,
                payload: error,
              });
        }
}

export const getTaobaoProducts=(body)=>async(dispatch)=>{
    try {
        const response = await useInsertData(`/api/v1/taobao/getTaobaoCart`, body);

        dispatch({
            type:GET_TAOBAO_PRODUCTS,
            payload:response
        });

    } catch (error) {
        dispatch({
            type: GET_TAOBAO_PRODUCTS,
            payload: error,
          });
    }
}

export const addTaoBaoProduct=({body,t})=>async(dispatch)=>{
    try {
         

        const response = await useInsertData(`/api/v1/taobao/query`, body);

        dispatch({
            type:SAVE_TAOBAO_PRODUCT,
            payload:response
        });

         notify(t("Adding Products..."), "success");

    } catch (error) {
        
        console.log('error',error.response.status);

        dispatch({
            type: SAVE_TAOBAO_PRODUCT,
            payload: error,
          });

          if(error.response.status==600){
            notify(t("this taobao product already exists"), "error");

          }
          else{
                notify(t("Try again later"), "error");

          }

    }
}

// RESET_TAOBAO_PRODUCTS
export const resetStoredTaoBaoProducts=()=>(dispatch)=>{
    try {
        dispatch({
            type: RESET_TAOBAO_PRODUCTS
          });
    } catch (error) {
        dispatch({
            type: RESET_TAOBAO_PRODUCTS,
            payload: error,
          });
    }
}